import { api as com, apiFuns } from "sw-hic";
let { get, post, put, del } = apiFuns;

const api = {
  Module: {
    ...apiFuns.genStandard("module", "/api/datacenter"),
    execSql:(para)=> post('/api/datacenter/module/exec', para)
  },
  Role: apiFuns.genStandard("role", "/api/md"),
};

export default api;
